import { observable } from "mobx";
import * as queryString from "qs";
import { routerStore } from "./WSRouter";

export const queryStringStore = observable({
  get qs() {
    return queryString.parse(routerStore.location.search.replace(/^\?/, ""));
  },
});

// prefixed all search params with cvp so its easy for customers to know what is reserved
export enum CVPSearchParams {
  /** id_rekruttering */
  cvpr = "cvpr",
  /** id_tilbud id_utleie */
  cvpt = "cvpt",
  /** adminTab */
  cvpat = "cvpat",
  /** step */
  cvpstep = "cvpstep",
  /** addingDocument */
  cvpad = "cvpad",
  /** editingExperience */
  cvpee = "cvpee",
  /** editingCourse */
  cvpec = "cvpec",
  /** editingEducation */
  cvpedu = "cvpedu",
  /** window.location.pathname is held in a search param when embedded in customer page */
  cvpage = "cvpage",
  /** firstjob */
  cvpfj = "cvpfj",
  /** search text */
  cvpst = "cvpst",
  /** position type */
  cvppt = "cvppt",
  /** categories */
  cvpcat = "cvpcat",
  /** counties */
  cvpct = "cvpct",
  /** municipalities */
  cvpmun = "cvpmun",
  /** sesjonsid */
  cvpssid = "cvpssid",
  /** terminalid */
  cvpttid = "cvpttid",
  /** token, used for QuestionForm, maybe more */
  cvptoken = "cvptoken",
  cvplocale = "cvplocale",
  cvpmonth = "cvpmonth",
  cvpyear = "cvpyear",
  /** id of a message */
  cvpmsgid = "cvpmsgid",
}
